/* eslint-disable */
export default {
  'signixfrontend': '521e62a2a03d0bb7dacb5c119def121ba1b25b8d8dddd47685cc96ee699da691',
  '@signiapp/core': '1.5.244',
  '@signiapp/helpers': '0.3.10',
  '@signicat/designi': '^0.5.44',
  '@signiapp/demonode': '0.2.27',
};
